import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=3db92a10&scoped=true&"
import script from "./nurse.vue?vue&type=script&lang=ts&"
export * from "./nurse.vue?vue&type=script&lang=ts&"
import style0 from "./nurse.vue?vue&type=style&index=0&id=3db92a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db92a10",
  null
  
)

export default component.exports